@if (formGroup) {
    <ng-container [formGroup]="formGroup">
        @for (control of formControlsConfig; track control) {
            <div class="grid-container">
                <div class="g-12 form-control">
                    <label
                        [for]="control.name + '_' + id"
                        appReactiveLabel
                        [formControlName]="control.name"
                        [forceDisable]="
                            control.type === 'select-with-input' && (obs[control.name] | async).length === 0
                        "
                    >
                        {{ control.label | formLabel: !!control.required }}:
                    </label>
                    <!-- #region text input -->
                    @if (control.type === 'text') {
                        <input
                            [id]="control.name + '_' + id"
                            type="text"
                            [placeholder]="
                                formGroup.get(control.name).disabled
                                    ? control.disabledPlaceholder
                                    : (control.placeholder || control.label | formLabel: !!control.required)
                            "
                            [formControlName]="control.name"
                            [required]="control.required"
                            [ctrlErrorMessage]="control.errorMsg"
                        />
                    }
                    <!-- #endregion -->
                    <!-- #region value input -->
                    @if (control.type === 'value') {
                        <input
                            [id]="control.name + '_' + id"
                            type="text"
                            appPriceInput
                            outputType="string"
                            [placeholder]="
                                formGroup.get(control.name).disabled
                                    ? control.disabledPlaceholder
                                    : (control.placeholder || control.label | formLabel: !!control.required)
                            "
                            [formControlName]="control.name"
                            [required]="control.required"
                            [ctrlErrorMessage]="control.errorMsg"
                        />
                    }
                    <!-- #endregion -->
                    <!-- #region select -->
                    @if (control.type === 'select') {
                        <select
                            [id]="control.name + '_' + id"
                            [formControlName]="control.name"
                            [required]="control.required"
                            [ctrlErrorMessage]="control.errorMsg"
                        >
                            <option
                                disabled
                                [value]="null"
                            >
                                {{
                                    formGroup.get(control.name).disabled
                                        ? control.disabledPlaceholder
                                        : (control.placeholder || control.label
                                          | formLabel: !!control.required : 'select')
                                }}
                            </option>
                            @for (option of obs[control.name] | async; track option) {
                                <option [ngValue]="option.value">
                                    {{ option.label }}
                                </option>
                            }
                        </select>
                    }
                    <!-- #endregion -->
                    <!-- #region date -->
                    @if (control.type === 'date') {
                        <input
                            [id]="control.name + '_' + id"
                            ctrlDateInput
                            type="text"
                            [placeholder]="control.label | formLabel: !!control.required : 'date'"
                            [formControlName]="control.name"
                            [required]="control.required"
                            [ctrlErrorMessage]="control.errorMsg"
                        />
                    }
                    <!-- #endregion -->
                    <!-- #region select with input -->
                    @if (control.type === 'select-with-input' && obs[control.name] | async; as options) {
                        <app-select-with-other-option
                            [options]="options"
                            [formControlName]="control.name"
                            [placeholder]="
                                options.length > 0
                                    ? (control.placeholder || control.label | formLabel: !!control.required : 'select')
                                    : control.disabledPlaceholder
                            "
                            [errorMessages]="control.errorMsg"
                        ></app-select-with-other-option>
                    }
                    <!-- #endregion -->
                </div>
            </div>
        }
    </ng-container>
}
